import { ApolloProvider } from '@apollo/client';
import LayoutRoute from '@platform-ui-common/components/LayoutRoute/index.js';
import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import 'regenerator-runtime/runtime';
import AppRoutes from './AppRoutes.js';
import apolloClient from './apolloClient.js';
import { ApplicantLayout } from './application/components/index.js';
import ErrorScreen from './application/pages/ErrorScreen/index.js';
import { PartnerProvider } from './common/hooks/contexts/usePartner.js';
import { SnackbarProvider } from './common/hooks/useSnackbar/index.js';
import './globals';
import { PageTitleProvider } from './common/hooks/contexts/usePageTitle.js';
import { initFaro } from './utilities/initFaro.js';

const rootElement = document.getElementById('root');
ReactModal.setAppElement(rootElement);

initFaro();

const root = createRoot(rootElement);
root.render(
  <ApolloProvider client={apolloClient}>
    <BrowserRouter>
      <Switch>
        {/* This is used to prevent every single route from needing to have the /:partnerId prefix. */}
        <Route path="/:partnerId">
          <PartnerProvider>
            <SnackbarProvider>
              <PageTitleProvider>
                <AppRoutes />
              </PageTitleProvider>
            </SnackbarProvider>
          </PartnerProvider>
        </Route>
        <LayoutRoute path="*" component={ErrorScreen} layout={ApplicantLayout} />
      </Switch>
    </BrowserRouter>
  </ApolloProvider>,
);
